import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';
import { ProfileShippingAddressValues } from '../Profile';
import { UserModel } from '../../../interfaces/user.interface';

export const updateUserProfile = async (
  values: {
    email: string;
    firstName: string;
    lastName: string;
    settings: any;
  },
  user: UserModel | null,
  successCallback?: ((value: boolean) => void) | null,
): Promise<void> => {
  try {
    const data: any = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      settings: values.settings,
    };
    // if (user?.saveDefaultShippingAddress) {
    //   data.shippingAddress = values.shippingAddress;
    // }
    const req = await callAPI('user/updateUser', data);
    if (req.success && successCallback) {
      successCallback(true);
    }
    Toast('Profile Updated Successfully');
  } catch (err) {
    Toast('User Profile Not Updated', true);
  }
};

export const updateUserPhipToAddress = async (
  values: {
    shippingAddress: ProfileShippingAddressValues;
  },
  successCallback?: ((value: boolean) => void) | null,
): Promise<void> => {
  try {
    const data: any = {
      shippingAddress: values.shippingAddress,
    };
    const req = await callAPI('user/updateUser/ship-address', data);
    if ((req.success || (req.status >= 200 && req.status < 300)) && successCallback) {
      successCallback(true);
      Toast('Ship-to address updated successfully');
    } else {
      Toast(req.error || 'Something went wrong');
    }
  } catch (err) {
    Toast('User Profile Not Updated', true);
  }
};

export const cancelUserSubscription = async (
  email: string,
  setPurchasePlan: (value: boolean) => void,
): Promise<void> => {
  try {
    const response = await callAPI('user/cancel-subscription', { email });

    Toast(response?.message || 'Unexpected Error Occurred', response?.status !== HTTPStatusEnum.OK);

    setPurchasePlan(false);
  } catch (error) {
    Toast('Failed to Cancel Subscription', true);
  }
};
